import React, { useState, useEffect, useMemo } from "react";
import { Redirect } from "react-router-dom";
import Papa from 'papaparse';
import UserService from "../services/user.service";
import ChartService from "../services/charts.service";
import TimeSeriesChart from './TimeSeriesChart';
import EventBus from "../common/EventBus";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import Heatmap from "./Heatmap";

import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  Card,
  Button,
  Chip,
  Avatar,
  Stack,
  Fade,
  Divider,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Tooltip,
  IconButton,
} from '@mui/material';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FlightIcon from '@mui/icons-material/Flight';
import MapIcon from '@mui/icons-material/Map';
import StorageIcon from '@mui/icons-material/Storage';
import CloseIcon from '@mui/icons-material/Close';

const GREEN = {
  900: "#1b5e20",
  800: "#2e7d32",
  700: "#388e3c",
  600: "#43a047",
  500: "#4caf50",
  400: "#66bb6a",
  100: "#c8e6c9",
  50: "#e8f5e9",
};

const center = {
  lat: 37.7755,
  lng: -120.7535
};

const Drone = () => {
  const [content, setContent] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [timeSeriesData, setTimeSeriesData] = useState([]);
  const [phenotypeData, setPhenotypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentFile, setCurrentFile] = useState("Verinomics Database Locations");
  const imgSrc = require("../img/googlemaps.png");
  const skySense = require("../img/skysense_v2.png");
  const [redirect, doRedirect] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const [anchorElProcessed, setAnchorElProcessed] = useState(null);
  const [anchorElRaw, setAnchorElRaw] = useState(null);

  const handleProcessedClick = (event) => {
    setAnchorElProcessed(event.currentTarget);
  };

  const handleRawClick = (event) => {
    setAnchorElRaw(event.currentTarget);
  };

  const handleProcessedClose = () => {
    setAnchorElProcessed(null);
  };

  const handleRawClose = () => {
    setAnchorElRaw(null);
  };

  const [blossomData, setBlossomData] = useState([]);

  let files = [
    "flight_log_2024-02-19_grid.csv",
    "flight_log_2024-02-20_grid.csv ",
    "flight_log_2024-02-27_grid.csv ",
    "flight_log_2024-03-04_grid.csv ",
    "flight_log_2024-03-08_grid.csv ",
    "flight_log_2024-03-09_grid.csv ",
    "flight_log_2024-03-16_grid.csv",
    "flight_log_2024-03-28_grid.csv ",
    "Flights_2024.csv",
    'flight_log_2025-01-14_grid.csv',
    'flight_log_2025-02-05_grid.csv',
    'flight_log_2025-02-07_grid_1.csv',
    'flight_log_2025-02-07_grid_2.csv',
    'flight_log_2025-02-18_grid.csv',
    'flight_log_2025-02-21_grid_1.csv',
    'flight_log_2025-02-21_grid_2.csv',
    'flight_log_2025-02-28_grid.csv',
    'flight_log_2025-03-03_grid_1.csv',
    'flight_log_2025-03-03_grid_2.csv',
    'flight_log_2025-03-18_grid.csv',
    'Flights_2025.csv',
  ];

  let rawFiles = [
    "flight_log_2024-02-19_metadata.csv",
    "flight_log_2024-02-20_metadata.csv",
    "flight_log_2024-02-21_metadata.csv",
    "flight_log_2024-02-28_metadata.csv",
    "flight_log_2024-02-26_metadata.csv",
    "flight_log_2024-02-27_metadata.csv",
    "flight_log_2024-03-04_metadata.csv",
    "flight_log_2024-03-05_metadata.csv",
    "flight_log_2024-03-06_metadata.csv",
    "flight_log_2024-03-07_metadata.csv",
    "flight_log_2024-03-08_metadata.csv",
    "flight_log_2024-03-09_metadata.csv",
    "flight_log_2024-03-11_metadata.csv",
    "flight_log_2024-03-16_metadata.csv",
    "flight_log_2024-03-28_metadata.csv",
    "Flights.csv",
    '2025-01-14_Jan 14, 2025 0419 - Jan 23, 2025 0357.csv',
    '2025-02-05_Feb 5, 2025 0120 - 0557.csv',
    '2025-02-07_Feb 7, 2025 0350 - Feb 12, 2025 0432.csv',
    '2025-02-07_Feb 7, 2025 0355 - 0414.csv',
    '2025-02-14_Feb 14, 2025 0549 - Feb 18, 2025 0624.csv',
    '2025-02-21_Feb 21, 2025 0618 - 0746.csv',
    '2025-02-21_Feb 21, 2025 0618 - Mar 11, 2025 0443.csv',
    '2025-02-28_Mar 4.csv',
    '2025-03-03_Mar 3, 11-12.csv',
    '2025-03-03_Mar 3, 2025 0253 - 0307.csv',
    '2025-03-18_Mar 18, 2025 0442 - 0538.csv',
  ];

  const containerStyle = {
    width: '100%',
    height: '100%'
  };
  const libraries = useMemo(() => ['visualization'], []);
  const googleMapsApiKey = 'AIzaSyCyS0717Gue3aDE3f8nmhYXiIYJDUDHKM4';

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey,
    libraries,
  });

  const onMarkerClick = (location) => {
    setSelectedLocation(null);
    setTimeSeriesData([]);
    setPhenotypeData([]);
    setTabValue(0);
    console.log("clicked: ", location);
    setTimeout(() => {
      setSelectedLocation(location);
      setShowModal(true);
    });
  };

  const handleModalClose = () => setShowModal(false);

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    const centerPoint = new window.google.maps.LatLng(center.lat, center.lng);
    map.setCenter(centerPoint);
    map.setZoom(19);
    setMap(map);
  }, [center]);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const fetchAndProcessCSV = async (file) => {
    console.log('file: ', file);
    try {
      const url = `${process.env.PUBLIC_URL}/processed_flights/${file.trim()}`;
      const response = await fetch(url);
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: true,
        complete: function (results) {
          console.log("csv: ", results);
          const markers = results.data.map(item => ({
            lat: parseFloat(item.Latitude),
            lng: parseFloat(item.Longitude),
            metadata: item,
          }));
          setLocations(markers);
          setCurrentFile(file.trim());
        },
        error: function (error) {
          console.error('Error parsing CSV:', error);
        }
      });
    } catch (error) {
      console.error('Failed to fetch and parse CSV:', error);
    }
  };

  const fetchRawCSV = async (file) => {
    console.log('file: ', file);
    try {
      const url = `${process.env.PUBLIC_URL}/raw_flights/${file.trim()}`;
      const response = await fetch(url);
      const csvText = await response.text();
      Papa.parse(csvText, {
        header: true,
        complete: function (results) {
          console.log("csv: ", results);
          const markers = results.data.map(item => ({
            lat: parseFloat(item.lat),
            lng: parseFloat(item.lon),
            metadata: item,
          }));
          setLocations(markers);
          setCurrentFile(file.trim());
        },
        error: function (error) {
          console.error('Error parsing CSV:', error);
        }
      });
    } catch (error) {
      console.error('Failed to fetch and parse CSV:', error);
    }
  };

  const handleDropdownChange = (event) => {
    // fetchAndProcessCSV( value );
  };

  const handleBloomTime = (event) => {
    console.log('location: ', selectedLocation);
    let idPlant = selectedLocation.metadata.Plant_idPlant;
    console.log("idPlant: ", idPlant);
    setLoading(true);
    ChartService.getBlossomCounts(idPlant).then(
      (response) => {
        console.log('blossom response: ', response);
        setTimeSeriesData(response.result);
        setLoading(false);
      },
      (error) => {
        console.log('error: ', error);
        alert("Bloom Time Series data only works with database locations.");
        setLoading(false);
      }
    );
  };

  const getDatabaseLocations = () => {
    ChartService.getPlantLocations({}).then(
      (response) => {
        console.log("locations success: ", response);
        const markers = response.result.map(item => {
          const [lat, lng] = item.gps.split(',').map(coord => parseFloat(coord.trim()));
          return { lat, lng, metadata: item };
        });
        console.log('markers: ', markers);
        setLocations(markers);
        setCurrentFile("Verinomics Database Locations");
      },
      (error) => {
        console.log("location error: ", error);
      }
    );
  };

  const handlePhenotypeClick = () => {
    let idPlant = selectedLocation.metadata.Plant_idPlant;
    console.log("idPlant: ", idPlant);
    setLoading(true);
    ChartService.getPhenotypesFromId(idPlant).then(
      (response) => {
        console.log('phenotype response: ', response);
        let data = response.result;
        data = data.map(entry => {
          if (entry.MeasurementType === "TimeStamp" && entry.PhenotypeMeasurementcol === "null") {
            entry.PhenotypeMeasurementcol = entry.Notes;
          }
          return entry;
        }).filter(entry => {
          return entry.PhenotypeMeasurementcol !== "null" && entry.PhenotypeMeasurementcol !== "";
        });
        console.log("data: ", data);

        if (data.length === 0) {
          console.warn("no phenos found..");
          setTimeout(() => {
            setLoading(false);
            alert("No Phenotypes found.");
          }, 1000);
        } else {
          setTimeout(() => {
            setPhenotypeData(data);
            setLoading(false);
          }, 500);
        }
      },
      (error) => {
        console.log('error: ', error);
        setLoading(false);
      }
    );
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      handlePhenotypeClick();
    } else if (newValue === 2) {
      handleBloomTime();
    }
  };

  useEffect(() => {
    UserService.getPublicContent().then(
      (response) => {
        console.log("response: ", response);
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        setContent(_content);
      }
    );

    ChartService.getPlantLocations({}).then(
      (response) => {
        console.log("locations success: ", response);
        const markers = response.result.map(item => {
          const [lat, lng] = item.gps.split(',').map(coord => parseFloat(coord.trim()));
          return { lat, lng, metadata: item };
        });
        console.log('markers: ', markers);
        setLocations(markers);
      },
      (error) => {
        console.log("location error: ", error);
      }
    );

    UserService.getUserBoard().then(
      (response) => {
        console.log("user response: ", response);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log("error: ", _content);
        doRedirect(true);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  if (redirect) {
    return <Redirect to="/login" />;
  }

  return isLoaded ? (
    <Container
      maxWidth="xl"
      disableGutters
      sx={{
        minHeight: "calc(100vh - 100px)",
        py: { xs: 3, md: 5 },
        px: { xs: 2, md: 3 },
      }}
    >
      {/* Hero Section */}
      <Fade in timeout={600}>
        <Paper
          elevation={0}
          sx={{
            px: { xs: 3, md: 6 },
            py: { xs: 4, md: 5 },
            mb: 4,
            borderRadius: 4,
            background: "#fff",
            border: "1px solid",
            borderColor: "grey.100",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: 120,
              height: 4,
              borderRadius: "0 0 4px 4px",
              background: `linear-gradient(90deg, ${GREEN[500]}, ${GREEN[400]})`,
            }}
          />

          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems="center"
            justifyContent="space-between"
            spacing={3}
          >
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar sx={{ width: 52, height: 52, bgcolor: GREEN[50] }}>
                <FlightIcon sx={{ fontSize: 28, color: GREEN[700] }} />
              </Avatar>
              <Box>
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    color: "#1a2e1a",
                    letterSpacing: "-0.02em",
                    lineHeight: 1.2,
                  }}
                >
                  Burchell Drone Data
                </Typography>
                <Typography variant="body2" sx={{ color: "#78909c", mt: 0.3 }}>
                  Flight logs, satellite mapping, and blossom count heatmaps.
                </Typography>
              </Box>
            </Stack>
            <Box
              component="img"
              src={skySense.default}
              alt="SkySense"
              sx={{ height: 60, objectFit: "contain" }}
            />
          </Stack>
        </Paper>
      </Fade>

      {/* Map Card */}
      <Fade in timeout={900}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid",
            borderColor: "grey.200",
            overflow: "hidden",
            mb: 4,
          }}
        >
          {/* Card Header — toolbar */}
          <Box
            sx={{
              px: 3,
              py: 2,
              bgcolor: GREEN[50],
              borderBottom: `2px solid ${GREEN[100]}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Box
                component="img"
                src={imgSrc.default}
                alt="Google Maps"
                sx={{ height: 36, borderRadius: 1 }}
              />
              <MapIcon sx={{ fontSize: 20, color: GREEN[700] }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: GREEN[900] }}>
                Flight Map
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              {/* Raw Files Button */}
              <Button
                aria-controls="raw-menu"
                aria-haspopup="true"
                onClick={handleRawClick}
                variant="contained"
                disableElevation
                endIcon={<ArrowDropDownIcon />}
                sx={{
                  bgcolor: GREEN[600],
                  color: "#fff",
                  borderRadius: 2,
                  px: 2.5,
                  py: 0.8,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "13px",
                  "&:hover": { bgcolor: GREEN[800] },
                }}
              >
                Raw Flight Logs
              </Button>
              <Menu
                id="raw-menu"
                anchorEl={anchorElRaw}
                keepMounted
                open={Boolean(anchorElRaw)}
                onClose={handleRawClose}
                PaperProps={{
                  sx: {
                    maxHeight: 360,
                    borderRadius: 2,
                    border: `1px solid ${GREEN[100]}`,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  },
                }}
              >
                {rawFiles.map((file, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => { fetchRawCSV(file); handleRawClose(); }}
                    sx={{
                      fontSize: "13px",
                      py: 1,
                      "&:hover": { bgcolor: GREEN[50] },
                    }}
                  >
                    {file}
                  </MenuItem>
                ))}
              </Menu>

              {/* Processed Files Button */}
              <Button
                aria-controls="processed-menu"
                aria-haspopup="true"
                onClick={handleProcessedClick}
                variant="contained"
                disableElevation
                endIcon={<ArrowDropDownIcon />}
                sx={{
                  bgcolor: GREEN[600],
                  color: "#fff",
                  borderRadius: 2,
                  px: 2.5,
                  py: 0.8,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "13px",
                  "&:hover": { bgcolor: GREEN[800] },
                }}
              >
                Processed Flight Logs
              </Button>
              <Menu
                id="processed-menu"
                anchorEl={anchorElProcessed}
                keepMounted
                open={Boolean(anchorElProcessed)}
                onClose={handleProcessedClose}
                PaperProps={{
                  sx: {
                    maxHeight: 360,
                    borderRadius: 2,
                    border: `1px solid ${GREEN[100]}`,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  },
                }}
              >
                {files.map((file, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => { fetchAndProcessCSV(file); handleProcessedClose(); }}
                    sx={{
                      fontSize: "13px",
                      py: 1,
                      "&:hover": { bgcolor: GREEN[50] },
                    }}
                  >
                    {file}
                  </MenuItem>
                ))}
              </Menu>

              {/* Database Locations Button */}
              <Tooltip title="Plants in our database matched with GPS locations from Skysense">
                <Button
                  variant="outlined"
                  onClick={getDatabaseLocations}
                  startIcon={<StorageIcon sx={{ fontSize: 16 }} />}
                  sx={{
                    color: GREEN[800],
                    borderColor: GREEN[400],
                    borderRadius: 2,
                    px: 2.5,
                    py: 0.8,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "13px",
                    "&:hover": {
                      borderColor: GREEN[700],
                      bgcolor: GREEN[50],
                    },
                  }}
                >
                  Database Locations
                </Button>
              </Tooltip>
            </Stack>
          </Box>

          {/* Currently Viewing Bar */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              px: 3,
              py: 1.5,
              bgcolor: "#fafbfa",
              borderBottom: "1px solid",
              borderColor: "grey.200",
            }}
          >
            <InsertDriveFileIcon sx={{ fontSize: 18, mr: 1, color: GREEN[600] }} />
            <Typography variant="body2" sx={{ color: "#78909c", mr: 1, fontWeight: 500 }}>
              Currently Viewing:
            </Typography>
            <Chip
              label={currentFile}
              size="small"
              sx={{
                bgcolor: GREEN[50],
                color: GREEN[800],
                fontWeight: 600,
                fontSize: "12px",
                border: `1px solid ${GREEN[400]}30`,
              }}
            />
          </Box>

          {/* Map */}
          <Box sx={{ width: "100%", height: "75vh", minHeight: 300 }}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={10}
              onLoad={onLoad}
              onUnmount={onUnmount}
              mapTypeId="satellite"
            >
              {locations.map((loc, idx) => (
                <Marker key={idx} position={{ lat: loc.lat, lng: loc.lng }} onClick={() => onMarkerClick(loc)} />
              ))}
            </GoogleMap>
          </Box>
        </Card>
      </Fade>

      <Divider sx={{ my: 4 }} />

      {/* Heatmap Card */}
      <Fade in timeout={1200}>
        <Card
          elevation={0}
          sx={{
            borderRadius: 3,
            border: "1px solid",
            borderColor: "grey.200",
            overflow: "hidden",
            pb: "100px",
          }}
        >
          <Box
            sx={{
              px: 3,
              py: 2,
              bgcolor: GREEN[50],
              borderBottom: `2px solid ${GREEN[100]}`,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Box
              component="img"
              src={imgSrc.default}
              alt="Google Maps"
              sx={{ height: 36, borderRadius: 1 }}
            />
            <MapIcon sx={{ fontSize: 20, color: GREEN[700] }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: GREEN[900] }}>
              Heatmap of Blossom Counts
            </Typography>
          </Box>
          <Box sx={{ width: "100%", height: "75vh", minHeight: 300 }}>
            <Heatmap
              setShowModal={setShowModal}
              setSelectedLocation={setSelectedLocation}
            />
          </Box>
        </Card>
      </Fade>

      {/* Location Details Dialog */}
      <Dialog
        open={showModal}
        onClose={handleModalClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            bgcolor: GREEN[50],
            borderBottom: `2px solid ${GREEN[100]}`,
            py: 2,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, color: GREEN[900] }}>
            Location Details
          </Typography>
          <IconButton onClick={handleModalClose} size="small" sx={{ color: "#78909c" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              px: 3,
              pt: 1,
              borderBottom: "1px solid",
              borderColor: "grey.200",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "14px",
                color: "#78909c",
                minHeight: 48,
                "&.Mui-selected": { color: GREEN[700] },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: GREEN[600],
                height: 3,
                borderRadius: "3px 3px 0 0",
              },
            }}
          >
            <Tab label="Location Details" />
            <Tab label="Phenotypes" />
            <Tab label="Bloom Time Series" />
          </Tabs>

          <Box sx={{ p: 3 }}>
            {/* Location Details Tab */}
            {tabValue === 0 && (
              selectedLocation ? (
                <List disablePadding>
                  {Object.entries(selectedLocation.metadata).map(([key, value], index) => (
                    <ListItem
                      key={index}
                      divider
                      sx={{
                        py: 1.2,
                        px: 2,
                        bgcolor: index % 2 === 0 ? "#fafbfa" : "#fff",
                        borderRadius: 1,
                      }}
                    >
                      <ListItemText
                        primary={
                          <Stack direction="row" spacing={1}>
                            <Typography
                              variant="body2"
                              sx={{ fontWeight: 700, color: GREEN[800], minWidth: 180 }}
                            >
                              {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#37474f" }}>
                              {value}
                            </Typography>
                          </Stack>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              ) : (
                <Typography variant="body2" sx={{ color: "#90a4ae" }}>
                  No data available.
                </Typography>
              )
            )}

            {/* Phenotypes Tab */}
            {tabValue === 1 && (
              phenotypeData.length > 0 ? (
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    border: "1px solid",
                    borderColor: "grey.200",
                    borderRadius: 2,
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ bgcolor: GREEN[50] }}>
                        {["Phenotype Name", "Measurement", "Description", "Type", "Notes", "Data File"].map((header) => (
                          <TableCell
                            key={header}
                            sx={{
                              fontWeight: 700,
                              fontSize: "12px",
                              color: GREEN[900],
                              textTransform: "uppercase",
                              letterSpacing: "0.03em",
                              borderBottom: `2px solid ${GREEN[400]}`,
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {phenotypeData.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(even)": { bgcolor: "#fafcfa" },
                            "&:hover": { bgcolor: GREEN[50] },
                          }}
                        >
                          <TableCell sx={{ fontSize: "13px" }}>{row.PhenotypeName}</TableCell>
                          <TableCell sx={{ fontSize: "13px", fontWeight: 600 }}>{row.PhenotypeMeasurementcol}</TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>{row.PhenotypeDescription}</TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>{row.MeasurementType}</TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>{row.Notes}</TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {row.DataFile ? (
                              <a
                                href={row.DataFile}
                                style={{ color: GREEN[700], fontWeight: 600, textDecoration: "none" }}
                              >
                                View File
                              </a>
                            ) : (
                              <Typography variant="caption" sx={{ color: "#bdbdbd" }}>N/A</Typography>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body2" sx={{ color: "#90a4ae" }}>
                  No phenotype data available.
                </Typography>
              )
            )}

            {/* Bloom Time Series Tab */}
            {tabValue === 2 && (
              <TimeSeriesChart data={timeSeriesData} />
            )}

            {/* Loading Indicator */}
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress sx={{ color: GREEN[600] }} />
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid",
            borderColor: "grey.200",
          }}
        >
          <Button
            onClick={handleModalClose}
            variant="outlined"
            sx={{
              color: "#546e7a",
              borderColor: "#cfd8dc",
              borderRadius: 2,
              px: 3,
              py: 0.8,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
              "&:hover": {
                borderColor: "#90a4ae",
                bgcolor: "#eceff1",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  ) : (
    <Container maxWidth="sm" sx={{ py: 10, textAlign: "center" }}>
      <CircularProgress sx={{ color: GREEN[600], mb: 2 }} />
      <Typography variant="body1" sx={{ color: "#78909c" }}>
        Loading Google Maps...
      </Typography>
    </Container>
  );
};

export default Drone;
